module.exports = __webpack_public_path__ + "img/status-support.d8c5a26b.png";